import { Mail, Phone } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-gray-50 dark:bg-gray-950 border-t border-gray-200 dark:border-gray-800 shadow-[0_-16px_40px_-12px_rgba(0,0,0,0.18)]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-8 pt-10 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-6">
          <div className="space-y-4">
            <h3 className="text-sm font-bold text-gray-900 dark:text-gray-100">
              CoreFares Consulting Pvt. Ltd.
            </h3>
            <p className="text-[13px] leading-relaxed text-gray-600 dark:text-gray-400">
              E303, Third Floor, Sunrise Chambers,
              <br />
              22 Ulsoor Road, Bangalore – 560 042
            </p>
          </div>

          <div className="space-y-4">
            <h3 className="text-sm font-bold text-gray-900 dark:text-gray-100">
              CoreFares Technology Pte. Ltd.
            </h3>
            <p className="text-[13px] leading-relaxed text-gray-600 dark:text-gray-400">
              30 Cecil Street, #19-08, Prudential Tower,
              <br />
              Singapore – 049712
            </p>
          </div>

          <div className="space-y-4">
            <h3 className="text-sm font-bold text-gray-900 dark:text-gray-100">
              Contact Us
            </h3>
            <div className="space-y-3">
              <a
                href="mailto:support@corefares.com"
                className="flex items-center gap-3 group no-underline"
              >
                <div className="w-8 h-8 flex items-center justify-center bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 group-hover:border-primaryColor dark:group-hover:border-primaryColor transition-colors">
                  <Mail
                    size={14}
                    className="text-gray-700 dark:text-gray-300 group-hover:text-primaryColor dark:group-hover:text-primaryColor transition-colors"
                  />
                </div>
                <span className="text-[13px] font-medium text-gray-700 dark:text-gray-300 group-hover:text-primaryColor dark:group-hover:text-primaryColor transition-colors">
                  support@corefares.com
                </span>
              </a>
              <a
                href="tel:+919845539988"
                className="flex items-center gap-3 group no-underline"
              >
                <div className="w-8 h-8 flex items-center justify-center bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 group-hover:border-primaryColor dark:group-hover:border-primaryColor transition-colors">
                  <Phone
                    size={14}
                    className="text-gray-700 dark:text-gray-300 group-hover:text-primaryColor dark:group-hover:text-primaryColor transition-colors"
                  />
                </div>
                <span className="text-[13px] font-medium text-gray-700 dark:text-gray-300 group-hover:text-primaryColor dark:group-hover:text-primaryColor transition-colors">
                  +91 98455 39988
                </span>
              </a>
            </div>
          </div>

          <div className="flex lg:justify-end items-start">
            <img
              src={`${import.meta.env.PUBLIC_CLOUDFRONT_BASE_URL}/icons/footer_logo.png`}
              alt="IATA Accredited"
              className="h-12 w-auto object-contain opacity-90"
            />
          </div>
        </div>

        <div className="border-t border-gray-200 dark:border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[12px] text-gray-500 dark:text-gray-500">
            &copy; {new Date().getFullYear()} CoreFares. All rights reserved
          </p>
          <div className="flex gap-6 sm:gap-10">
            <Link
              to="https://corefares.com/privacy-policy/"
              target="_blank"
              className="text-[12px] font-semibold text-gray-600 dark:text-gray-400 hover:text-primaryColor dark:hover:text-primaryColor no-underline transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="https://corefares.com/terms-conditions/"
              target="_blank"
              className="text-[12px] font-semibold text-gray-600 dark:text-gray-400 hover:text-primaryColor dark:hover:text-primaryColor no-underline transition-colors"
            >
              Terms &amp; Conditions
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
